import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function MemberWorkouts() {
  const [plans, setPlans]   = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [logging, setLogging] = useState(false);
  const [log, setLog]       = useState({ duration_mins:60, notes:'' });
  const [msg, setMsg]       = useState('');

  useEffect(() => {
    Promise.all([axios.get('/member/workouts'), axios.get('/member/workouts/history')])
      .then(([p, h]) => { setPlans(p.data); setHistory(h.data); }).finally(() => setLoading(false));
  }, []);

  const logSession = async e => {
    e.preventDefault(); setLogging(true);
    try {
      await axios.post('/member/workouts/log', { ...log, plan_id: plans[0]?.id });
      setMsg('Session logged!'); setLog({ duration_mins:60, notes:'' });
      const h = await axios.get('/member/workouts/history'); setHistory(h.data);
    } catch { setMsg('Error logging.'); } finally { setLogging(false); }
  };

  if (loading) return <div className="loading-wrap"><div className="spinner"></div></div>;

  const plan = plans[0];
  const exercises = plan ? JSON.parse(plan.exercises || '[]') : [];

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">My workouts</h1><p className="page-sub">{plan ? `Week ${plan.week_number} — ${plan.title}` : 'No active plan'}</p></div></div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {plan ? (
            <div className="card">
              <div className="card-header"><div className="card-title">🏋️ {plan.title}</div><span style={{ fontSize:11, color:'var(--text-muted)' }}>Week {plan.week_number}</span></div>
              <div>
                {exercises.map((ex, i) => (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 18px', borderBottom:'1px solid var(--border)' }}>
                    <div style={{ width:26, height:26, borderRadius:'50%', background:'var(--accent-dim)', color:'var(--accent)', fontSize:11, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{i+1}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:500 }}>{ex.name}</div>
                      <div style={{ fontSize:11, color:'var(--text-muted)' }}>{ex.sets} sets × {ex.reps} reps {ex.weight ? `· ${ex.weight}` : ''}</div>
                    </div>
                    {ex.rest && <div style={{ fontSize:11, color:'var(--text-muted)', whiteSpace:'nowrap' }}>Rest {ex.rest}s</div>}
                  </div>
                ))}
                {exercises.length === 0 && <div className="empty-state" style={{ padding:24 }}><p>No exercises added to this plan yet.</p></div>}
              </div>
              {plan.notes && <div style={{ padding:'12px 18px', borderTop:'1px solid var(--border)', fontSize:12, color:'var(--text-secondary)', lineHeight:1.6 }}>📝 {plan.notes}</div>}
            </div>
          ) : (
            <div className="card"><div className="empty-state" style={{ padding:40 }}><div className="icon">🏋️</div><p>No workout plan assigned yet. Ask your trainer.</p></div></div>
          )}

          {/* Log session */}
          <div className="card">
            <div className="card-header"><div className="card-title">✍️ Log today's session</div></div>
            <form onSubmit={logSession} style={{ padding:18 }}>
              {msg && <div style={{ marginBottom:12, padding:'9px 14px', borderRadius:'var(--radius)', background:'var(--success-dim)', color:'var(--success)', fontSize:13 }}>{msg}</div>}
              <div className="form-group"><label className="label">Duration (minutes)</label><input className="input" type="number" value={log.duration_mins} onChange={e => setLog(p=>({...p,duration_mins:e.target.value}))} /></div>
              <div className="form-group"><label className="label">Notes</label><textarea className="input" rows={3} placeholder="How did it go?" value={log.notes} onChange={e => setLog(p=>({...p,notes:e.target.value}))} style={{ resize:'vertical' }} /></div>
              <button className="btn-primary" type="submit" disabled={logging} style={{ width:'100%', justifyContent:'center' }}>{logging ? 'Saving…' : 'Log session'}</button>
            </form>
          </div>
        </div>

        {/* History */}
        <div className="card">
          <div className="card-header"><div className="card-title">📜 Session history</div></div>
          {history.length === 0 ? <div className="empty-state" style={{ padding:32 }}><p>No sessions logged yet.</p></div> : (
            <div>
              {history.map(s => (
                <div key={s.id} style={{ padding:'12px 18px', borderBottom:'1px solid var(--border)' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                    <div style={{ fontSize:13, fontWeight:500 }}>{new Date(s.date).toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short' })}</div>
                    <span style={{ fontSize:12, color:'var(--success)', fontWeight:600 }}>⏱ {s.duration_mins} min</span>
                  </div>
                  {s.notes && <div style={{ fontSize:12, color:'var(--text-secondary)' }}>{s.notes}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
